import {buildQuestionItemRegionId} from 'client/components/PracticeView/Annotations/annotationRegions';

import {isSupplement} from './utils';

// The ordering and item-bank stores' stand-ins for an unauthored item id and an unanswered slot.
const POSITIONAL_ITEM_ID = /^(word|empty)-\d+$/;

/**
 * The annotation region for an item's chip text. Null for a positional stand-in id, which
 * cannot persist, and for a supplement item, whose chip stays fenced.
 */
export const itemRegionIdFor = (
  questionId: string | null | undefined,
  item: {id: string; value: string}
): string | null =>
  questionId && item.id && !POSITIONAL_ITEM_ID.test(item.id) && !isSupplement(item.value)
    ? buildQuestionItemRegionId(questionId, item.id)
    : null;
